<template>
  <div class="iwp-breadcrumbs col-12 text-center flex items-center justify-between justify-md-center">
    <ws-icon
      v-if="mobile && currentStep !== 0"
      class="icon cursor-pointer"
      name="arrow_left"
      :size="24"
      @click="flowConfigs[flowId][currentStep - 1].nav()"
    />

    <template v-for="(step, index) in flow">
      <template v-if="!mobile || (mobile && currentStep === index)">
        <span :key="'span-'+index" class="cursor-pointer" :class="{active: index === currentStep}" @click="step.nav">
          {{ $t(step.title) }}
        </span>
        <div v-if="index !== flow.length -1 && !mobile" :key="'separator-'+index">
          &mdash;
        </div>
      </template>
    </template>


    <ws-icon
      v-if="mobile && currentStep !== flow.length -1"
      name="arrow_left"
      :size="24"
      class="rotate-180 icon cursor-pointer"
    />
  </div>
</template>

<script lang="ts">
import {computed, defineComponent, type Ref, ref} from 'vue';
import {WsIcon} from '@loopia-group/components-vue2';
import {useRoute, useRouter} from 'vue-router/composables';


export default defineComponent({
  name: 'ProductFlowStepper',
  components: {
    WsIcon,
  },
  props: {},
  setup() {
    const route = useRoute();
    const router = useRouter();
    type FlowId = 'website';
    const flowId: Ref<FlowId> = ref('website' as FlowId);

    const currentStep = computed(() => flow.value.findIndex((step) => step.isCurrent()));

    const flowConfigs = {
      website: [
        {
          title: 'modules.i_want_product.website.breadcrumbs.step_1',
          isCurrent: () => route.name === 'domain-checker',
          nav: () => {
            router.push({
              name: 'domain-checker',
              query: {
                flow: 'website',
                qd: route.query.domain || '',
              }
            });
          },
        },
        {
          title: 'modules.i_want_product.website.breadcrumbs.step_2',
          isCurrent: () => route.name === 'IWP',
          nav: () => {},
        },
        {
          title: 'modules.i_want_product.website.breadcrumbs.step_3',
          isCurrent: () => false,
          nav: () => {},
        }
      ]
    };

    const flow = computed(() => flowConfigs[flowId.value]);

    return {route, flowId, currentStep, flowConfigs, flow};
  },

});
</script>

<style scoped lang="scss">
.iwp-breadcrumbs {
  margin-bottom: 25px;
  font-weight: 700;
  font-size: 14px;
  line-height: 17.5px;

  @media #{$tablet} {
    margin-top: 25px;
    color: transparent;
  }

  .active {
    display: inline-block;
    color: $ws-text-color-dark;
  }

  ::v-deep > span, ::v-deep > a {
    display: inline-flex;
    padding: 0 8px;
    color: #737373;
  }

  ::v-deep > .icon {
    color: $ws-text-color-dark;
  }
}
</style>
